import { render, staticRenderFns } from "./CardImage.vue?vue&type=template&id=12e530ae"
import script from "./CardImage.vue?vue&type=script&lang=js"
export * from "./CardImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports